function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import extractErrors from './extractErrors';
const wrappedCache = new WeakMap();
export default function wrapFetchWithErrors(fetch) {
    const wrappedFetch = wrappedCache.get(fetch);
    if (wrappedFetch) {
        return wrappedFetch;
    }
    const newWrappedFetch = function() {
        var _withErrorsFetch = _async_to_generator(function*(...args) {
            const response = yield fetch(...args);
            if (response.ok) {
                return response;
            } else {
                return extractErrors(response);
            }
        });
        function withErrorsFetch() {
            return _withErrorsFetch.apply(this, arguments);
        }
        return withErrorsFetch;
    }();
    wrappedCache.set(fetch, newWrappedFetch);
    return newWrappedFetch;
}

//# sourceMappingURL=wrapFetchWithErrors.js.map